// Critical-fields contract — see aegle-docs critical_fields_contract.md
import { ClaimItemCreate } from "@/types";
import {
  validateDateRange,
  validateNotFutureDate,
  validateMinValue,
  validateRequired,
} from "../helpers/validationHelpers";

export const validateClaimItems = (values: ClaimItemCreate): Record<string, string> => {
  const errors: Record<string, string> = {};

  // --- Required Fields (per backend NOT NULL constraints) ---
  validateRequired(values.claimant_id_ref, "claimant_id_ref", errors);
  validateRequired(values.client_id_ref, "client_id_ref", errors, "Client is required");
  validateRequired(values.claim_type, "claim_type", errors);
  validateRequired(values.claim_status, "claim_status", errors);
  validateRequired(values.source_claim_id, "source_claim_id", errors);
  validateRequired(values.primary_diagnosis, "primary_diagnosis", errors);
  validateRequired(values.procedure_code, "procedure_code", errors);

  // --- Financial Validations ---
  if (values.member_oop !== undefined) {
    validateMinValue(values.member_oop, "member_oop", errors);
  }
  if (values.paid_amount !== undefined) {
    validateMinValue(values.paid_amount, "paid_amount", errors);
  }
  if (values.billed_amount !== undefined) {
    validateMinValue(values.billed_amount, "billed_amount", errors);
  }
  if (values.eligible_amount !== undefined) {
    validateMinValue(values.eligible_amount, "eligible_amount", errors);
  }
  if (values.deductible_amount !== undefined) {
    validateMinValue(values.deductible_amount, "deductible_amount", errors);
  }
  if (values.coinsurance_amount !== undefined) {
    validateMinValue(values.coinsurance_amount, "coinsurance_amount", errors);
  }
  if (values.copay_amount !== undefined) {
    validateMinValue(values.copay_amount, "copay_amount", errors);
  }

  // --- Date Range Validations ---
  validateDateRange(values.date_of_service_start, values.date_of_service_end, "date_of_service", errors);

  // --- Date Future Validations ---
  if (values.date_of_service) {
    validateNotFutureDate(values.date_of_service, "date_of_service", errors, "Date of service cannot be in the future");
  }
  if (values.paid_date) {
    validateNotFutureDate(values.paid_date, "paid_date", errors, "Paid date cannot be in the future");
  }

  // --- Logical Validations ---
  if (
    values.billed_amount !== undefined &&
    values.paid_amount !== undefined &&
    values.paid_amount > values.billed_amount
  ) {
    errors["paid_amount"] = "Paid amount cannot exceed billed amount";
  }
  if (
    values.billed_amount !== undefined &&
    values.eligible_amount !== undefined &&
    values.eligible_amount > values.billed_amount
  ) {
    errors["eligible_amount"] = "Eligible amount cannot exceed billed amount";
  }

  return errors;
};
